import React from "react";
import {Chip, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {convertDateToTimeString} from "../utils/cert-helper";
import {CustomATage} from "../ExternalSourceManagement/ExternalSourceTable";


const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold',
})

export default function NpiLogsTable(props) {

    const npiLogs = props.npiLogs;

    return (
        <TableContainer sx={{maxHeight: '600px', '& .MuiTableCell-root': {paddingLeft: '4px', paddingRight: '4px'}}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data Source</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>Data Path</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Imported Record Count</StyledTableCell>
                        <StyledTableCell>Created Time</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Status</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {npiLogs && npiLogs.map((log, i) => {
                        return (
                                <TableRow key={i}>
                                    <TableCell>{log.datasource}</TableCell>
                                    <TableCell>{log.description}</TableCell>
                                    <TableCell sx={{ maxWidth: '350px', wordBreak: 'break-all'}}><CustomATage size='14px' path={log.dataPath}/></TableCell>
                                    <TableCell sx={{ textAlign: 'center'}}>{log.importedRecordCount}</TableCell>
                                    <TableCell>{convertDateToTimeString(log.createdTs)}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        {log.completed ? <Chip variant='outlined' label="COMPLETED" color="success" icon={<CheckCircleIcon/>}/>
                                            : <Chip label="UNCOMPLETED" color="warning" variant='outlined'/>}
                                    </TableCell>
                                </TableRow>
                            )
                    })}

                </TableBody>
            </Table>
        </TableContainer>
    )


}
